<template>
    <div v-if="hasCustomDefs" class="wrapper d-flex flex-column">
		<v-form>
		<v-row align="center" class="pa-2"><v-col>

			<v-expansion-panels
			v-model="panels"
			multiple
			hover
			focusable>
				<v-expansion-panel
				v-for="(item,i) in getUniqeClasses" :key="i">
					<v-expansion-panel-header>
						<v-row class="ma-0">
							<v-col class="pa-0" cols="12" md="2"><b>{{item.classname}}</b></v-col>
							<v-col class="pa-0" cols="12" md="10" align="center">
								<v-row v-if="panels.includes(i)" @click.stop="">
										<v-col cols="12" md="3" class="pt-6"><b>{{$t('text.setAge4All')}}:</b></v-col>
										<v-col cols="12" md="2">
											<v-text-field outlined dense
												hide-details="auto"
												type="number"
												:label="$t('text.startAge')"
												v-model.number="item.startAge">
											</v-text-field>
										</v-col>
										<v-col cols="12" md="2">
											<v-text-field outlined dense
												hide-details="auto"
												type="number"
												:label="$t('text.endAge')"
												v-model.number="item.endAge">
											</v-text-field>
										</v-col>
										<v-col cols="12" md="2">
											<v-btn
												class="mr-4"
												@click="setAgeToAll(i)">
												{{ $t(`text.save`) }}
											</v-btn>
										</v-col>
								</v-row>
							</v-col>
						</v-row>
					</v-expansion-panel-header>
					<v-expansion-panel-content v-if="panels.includes(i)">
						<div v-for="(row, y) in customEventClasses.filter(x => x.classId == item.classId)" :key="y">
							<v-lazy
								v-model="isActive"
								:options="{
									threshold: .5
								}"
								min-height="70"
								transition="fade-transition">
								<v-row>
									<v-col cols="12" md="2"><b>{{row.eventname}}</b></v-col>
									<v-col cols="12" md="2">
										<v-text-field outlined dense
											hide-details="auto"
											type="number"
											:label="$t('text.heightWeight')"
											v-model="row.heightWeight">
										</v-text-field>
									</v-col>
									<v-col cols="12" md="2">
										<v-switch dense
											class="mt-0"
											v-model="row.wind"
											:label="$t('text.windResult')"
										></v-switch>
									</v-col>
									<v-col cols="12" md="2">
										<v-switch dense
											class="mt-0"
											v-model="row.handTimeAllowed"
											:label="$t('text.handTime')"
										></v-switch>
									</v-col>
									<v-col cols="12" md="1">
										<v-text-field outlined dense
											hide-details="auto"
											type="number"
											:label="$t('text.startAge')"
											v-model="row.startAge">
										</v-text-field>
									</v-col>
									<v-col cols="12" md="1">
										<v-text-field outlined dense
											hide-details="auto"
											type="number"
											:label="$t('text.endAge')"
											v-model="row.endAge">
										</v-text-field>
									</v-col>
									<v-col cols="12" md="2">
										<v-select outlined dense
											hide-details="auto"
											:label="$t('text.environment')"
											:items="environmentList"
											v-model="row.environment">
										</v-select>
									</v-col>
								</v-row>
							</v-lazy>
						</div>
					</v-expansion-panel-content>
				</v-expansion-panel>
			</v-expansion-panels>
		</v-col></v-row>
		</v-form>
		<v-spacer></v-spacer>
		<div class="f-row pb-1">
			<v-btn
				class="mr-4"
				@click="saveCustomDefValues">
				{{ $t(`text.createButton`) }}
			</v-btn>
			<v-btn
				class="mr-4"
				@click="back">
				{{ $t(`text.backButton`) }}
			</v-btn>
		</div>
	</div>
</template>

<script>

import getEnvSelectorList from '../models/environmentSelector';


export default {
	name: 'CustomDefValues',
	props: {
		customEventClasses: {
			required: true,
		},
	},
	data() {
		return {
			sortedCustomDefs: [],
			id: this.$route.params.id || null,
			panels: [],
			isActive: false,
		};
	},
	mounted() {
		const classIds = this.customEventClasses.map(x => x.classId).filter((v, i, s) => s.indexOf(v) === i);
		this.sortedCustomDefs = classIds.map(x => this.customEventClasses.find(y => y.classId == x));
		this.$nextTick(() => {
			this.$emit('onlaodingfinished');
		});
	},
	computed: {
		hasCustomDefs() {
			return this.getUniqeClasses && this.getUniqeClasses.length != 0;
		},
		getUniqeClasses() {
			return this.sortedCustomDefs;
		},
		environmentList() {
			return getEnvSelectorList(this);
		},
	},
	methods: {
		setAgeToAll(i) {
			const item = this.getUniqeClasses[i];
			if (item.startAge > 0 && (item.endAge > 0 && item.endAge >= item.startAge)) {
				this.customEventClasses.filter(v => v.classId === item.classId).forEach((y) => {
					y.startAge = item.startAge;
					y.endAge = item.endAge;
				});
			} else {
			// eslint-disable-next-line no-restricted-globals, no-alert
				window.alert(this.$t('text.errorInvalidInput'));
			}
		},
		saveCustomDefValues() {
			this.$emit('onlaodingstarted');
			this.panels = [];
			const payload = this.customEventClasses.map(x => ({
				id: x.id, startAge: parseInt(x.startAge, 10), endAge: parseInt(x.endAge, 10), heightWeight: parseInt(x.heightWeight, 10), wind: x.wind, environment: x.environment, handTimeAllowed: x.handTimeAllowed,
			}));

			this.$emit('onupdatecustomdef', payload);
		},
		back() {
			this.$router.push({
				name: 'customDefinitionsMatrix',
				params: {
					id: this.id,
				},
			});
		},
	},
};
</script>

<style lang="scss" scoped>

form {

    max-height: 100%;
	overflow: hidden;
    overflow-y: auto;
}
.wrapper {
	height: 100%;
}

</style>
